module.exports = __webpack_public_path__ + "img/mission-1.ae9a9656.png";